import * as angular from "angular";
import {IController} from "angular";
import {ItinerariesTasksSettings} from "../../../agents/angular/models/itineraries-tasks-settings.model";
import {SplitService} from "../../../commons/services/split-service.service";
import {TaskModel} from "../../models/task.model";

export class taskItemCtrl implements IController {

  task: TaskModel;
  analysis: any;
  taskIndex: number;
  isSelected: boolean;
  isHighlighted: boolean;
  itinerariesTaskSettings: ItinerariesTasksSettings
  onTaskSelectToggle: Function;

  public showRelatedTaskList: any;
  public purposeToServiceType: any;
  public configZoneId: any;

  /* @ngInject */
  constructor(private $task, private tasksConstants, private splitService: SplitService, private $mdMedia) {
  }

  $onInit() {
    this.showRelatedTaskList = false;
    this.purposeToServiceType = this.tasksConstants.purposeToServiceType;
    this.configZoneId = this.splitService.getTimeZone();
  };

  onChangeStatus(task, status) {
    this.task = task;
  }

}

angular
  .module('bringoz.admin.tasks')
  .component('taskItem', {
    bindings: {
      task: '<',
      analysis: '<',
      taskIndex: '<',
      isSelected: '<',
      isHighlighted: '<',
      itinerariesTaskSettings: '<',
      onTaskSelectToggle: '&'
    },
    template: require('./task-item.html').default,
    controller: taskItemCtrl
  });

